// extracted by mini-css-extract-plugin
export default {"chat":"style_chat__Us9ju"};